import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";


const initialState = {
  value: [],
  loading: false,
};

export const addTimedDraws = createAsyncThunk(
  "timedDraws/addTimedDraws",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.addOrder(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const addTimedDrawsSlice = createSlice({
  name: "addTimedDraws",
  initialState,
  reducers: {
    clearAddTimedDrawResponse(state, action) {
      state.value = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addTimedDraws.pending, (state) => {
        state.loading = true;
      })
      .addCase(addTimedDraws.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(addTimedDraws.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const addTimedDrawsList = (state) => state.addTimedDraws.value;
export const { clearAddTimedDrawResponse } = addTimedDrawsSlice.actions;
export default addTimedDrawsSlice.reducer;
